export const SNIPPET = 'snippet'
export const EXAMPLE = 'example'
export const MATCH_SNIPPETS_PREFIX = /^[./]*snippets\//
export const MATCH_EXAMPLES_PREFIX = /^[./]*examples\//
export const LANGUAGE_EXTENSIONS = {
  bash: 'bash',
  css:  'css',
  html: 'html',
  js:   'javascript',
  ts:   'typescript',
  json: 'json',
  jsx:  'jsx',
  tsx:  'tsx',
  md:   'markdown',
  mdx:  'mdx',
  scss: 'scss',
  sh:   'bash',
  yaml: 'yaml',
}
